module.exports = __webpack_public_path__ + "static/img/pCT7.852f6371.png";